import {SanteFamilleCodeEnum} from "src/modules/tarificateur/model/sante-famille-code.enum";

const combinaisonToTablePositions = (combinaison) => {
    let match = combinaison.match(/H(\d)D(\d)O(\d)M(\d)P(\d)/)
    console.debug('[combinaisonUtils]', 'combinaisonToTablePositions', match)

    const positions = []
    if (match !== null) {
        positions[SanteFamilleCodeEnum.HOSPITALISATION] = {col: parseInt(match[1]), row: undefined}
        positions[SanteFamilleCodeEnum.DENTAIRE] = {col:parseInt(match[2]), row: undefined}
        positions[SanteFamilleCodeEnum.OPTIQUE] = {col:parseInt(match[3]), row: undefined}
        positions[SanteFamilleCodeEnum.MEDECINE] = {col:parseInt(match[4]), row: undefined}
        positions[SanteFamilleCodeEnum.PREVENTION] = {col:parseInt(match[5]), row: undefined}

        return positions
    }

    match = combinaison.match(/H(\d)/)
    console.debug('[combinaisonUtils]', 'combinaisonToTablePositions', match)

    if (match !== null) {
        positions[SanteFamilleCodeEnum.HOSPITALISATION] = {col:parseInt(match[1]), row: undefined}

        return positions
    }

    return positions
}

const tablePositionsToCombinaison = (tablePositions) => {
    console.debug('[combinaisonUtils]', 'tablePositionsToCombinaison', tablePositions)
    if (tablePositions[SanteFamilleCodeEnum.HOSPITALISATION] === undefined) {
        return ''
    }

    let combinaison =
        `H${tablePositions[SanteFamilleCodeEnum.HOSPITALISATION].col}` +
        `D${tablePositions[SanteFamilleCodeEnum.DENTAIRE].col}` +
        `O${tablePositions[SanteFamilleCodeEnum.OPTIQUE].col}` +
        `M${tablePositions[SanteFamilleCodeEnum.MEDECINE].col}` +
        `P${tablePositions[SanteFamilleCodeEnum.PREVENTION].col}`

    return combinaison
}

const calculateCombinaisonFromOldToAsked = (currentCombinaison, cell, maxEcart) => {
    console.debug('[combinaisonUtils]', 'currentCombinaison', currentCombinaison)
    maxEcart = parseInt(maxEcart)
    const selectedCol = cell.position.col
    if (cell.tag === SanteFamilleCodeEnum.PREVENTION) {
        return currentCombinaison.replace(/P\d/, `P${selectedCol}`)
    }

    if ((maxEcart === 0 || cell.position.col === 9)) {
        return currentCombinaison.replace(/H\dD\dO\dM\d/, `H${selectedCol}D${selectedCol}O${selectedCol}M${selectedCol}`)
    } else {
        // Cas spécifique si on vient de H9D9O9M9PX et que l'on clique sur autre chose qu'un niveau 9
        // Le niveau 9 n'est alors plus disponible
        if (currentCombinaison.match(/9/)) {
            currentCombinaison = currentCombinaison.replace(/9/g, '8')
            console.debug('[combinaisonUtils]', 'current combinaison hack',currentCombinaison)
        }

        const tablePositions = combinaisonToTablePositions(currentCombinaison)

        tablePositions[cell.tag].col = selectedCol

        for (const [, famille] of Object.entries(SanteFamilleCodeEnum)) {
            if (famille !== cell.tag && famille !== SanteFamilleCodeEnum.PREVENTION) {
                if (selectedCol - tablePositions[famille].col > maxEcart) {
                    tablePositions[famille].col = selectedCol - maxEcart
                } else if (tablePositions[famille].col - selectedCol > maxEcart) {
                    tablePositions[famille].col = selectedCol + maxEcart
                }
            }
        }

        return tablePositionsToCombinaison(tablePositions)
    }
}

export {
    combinaisonToTablePositions,
    tablePositionsToCombinaison,
    calculateCombinaisonFromOldToAsked
}
